module.exports = __webpack_public_path__ + "images/ca41a65.jpg";